import DemoRenderer__LegacyDemoInstructions from '@runtime/DemoRenderer';
import InterfaceRenderer__LinkInstructions from '@runtime/TypescriptMetadataRenderer/interface';
import DemoRenderer__LinkInstructions from '@runtime/DemoRenderer';
import legacyImportDemo_2947125131 from "../../../../../packages/component/src/components/transfer/demo/demo1.js?loadDemo";
import legacyImportDemo_1493471272 from "../../../../../packages/component/src/components/transfer/demo/demo2.js?loadDemo";
import legacyImportDemo_1438468297 from "../../../../../packages/component/src/components/transfer/demo/demo3.js?loadDemo";
import legacyImportDemo_545905006 from "../../../../../packages/component/src/components/transfer/demo/demo4.js?loadDemo";
import legacyImportDemo_1692542735 from "../../../../../packages/component/src/components/transfer/demo/demo5.js?loadDemo";
import * as React from 'react';
export default {
  DemoRenderer__LegacyDemoInstructions,
  InterfaceRenderer__LinkInstructions,
  DemoRenderer__LinkInstructions,
  legacyImportDemo_2947125131,
  legacyImportDemo_1493471272,
  legacyImportDemo_1438468297,
  legacyImportDemo_545905006,
  legacyImportDemo_1692542735,
  React
};